module.exports = __webpack_public_path__ + "static/img/logo.c429d487.png";